import React from "react";
import carQrCodeImg from "../../../../assets/images/keyless-return/car-qr-code.svg";
import icoInfoOrange from "../../../../assets/images/ico-info-orange.svg";

export function ReadQrCode({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <img
        src={carQrCodeImg}
        alt="Ilustração QR Code"
        className="return-image"
      />

      <p className="return-subtitle">
        {t("keylessReturnScanInstruction")}
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          marginTop: "1rem",
        }}
      >
        <img
          src={icoInfoOrange}
          alt=""
          style={{ width: "24px", height: "24px", marginBottom: "8px" }}
        />
        <p style={{ fontSize: "14px", margin: 0 }}>
          {t("keylessReturnScanWarning")}
        </p>
      </div>
    </div>
  );
}

